import * as colors from './colors';

const REFRESH_INTERVAL = 300000;

export { REFRESH_INTERVAL, colors };
